import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { ProgressState, progressAdapter } from './progressSlicer';

export const {
    selectAll: selectAllUploads,
    selectById: selectByUploadId,
    selectTotal: selectTotalUploads,
    selectIds: selectUploadIds
} = progressAdapter.getSelectors<RootState>(state => state.uploads);

export const selectUploadWorking = createSelector(selectAllUploads, state =>
    state.some(x => x.state === ProgressState.WAIT || x.state === ProgressState.IN_PROGRESS)
);
